import { useEffect, useMemo } from 'react'

import { type ArticleReportType } from '@/defs/articleReport'
import { useCardsRec } from '@/hooks/useCardsRec'

type Props = {
  number: number
  onResolve: (number: number, result: ArticleReportType) => void
  report: ArticleReportType
}

export const ArticleReportReporter = ({ number, onResolve, report }: Props) => {
  const { rec } = report
  const { card, hasError, loading } = useCardsRec({ enabled: true, rec })

  const recReportUpdated = useMemo<ArticleReportType>(() => {
    if (!rec) return { ...report, status: 'unknown' }
    if (hasError) return { ...report, status: 'cardLoadError' }
    if (loading) return { ...report, status: 'cardLoading' }
    if (!card) return { ...report, status: 'unknown' }
    return { ...report, status: 'cardLoadSuccess' }
  }, [card, hasError, loading, rec, report])

  useEffect(() => {
    onResolve(number, recReportUpdated)
  }, [number, onResolve, recReportUpdated])

  return null
}
